import MuiSlider from '@material-ui/core/Slider';
import { makeStyles, withStyles } from '@material-ui/core/styles';

/**
 * @todo it looks like a lot of these styles could be standardized to our theme + Box and Grid
 * - https://material-ui.com/components/box/
 * - https://material-ui.com/components/grid/
 **/
export const StyledSlider = withStyles(theme => ({
  root: {
    height: 2,
    margin: '0 12px',
    bottom: 2,
    display: 'block'
  },
  thumb: {
    // Thumb is the actual 'blip' the user clicks+drags
    height: 12,
    width: 12,
    backgroundColor: theme.palette.primary.main,
    '&:focus,&:hover,&$active': {
      boxShadow:
        '0 0px 0px rgba(0,0,0,0),0 0px 0px rgba(0,0,0,0),0 0 0 0px rgba(0,0,0,0)',
      '@media (hover: none)': {}
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 11px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000'
    }
  },
  track: {
    height: 2
  },
  rail: {
    height: 2,
    opacity: 0.5,
    backgroundColor: theme.palette.secondary.light
  },
  mark: {
    backgroundColor: 'rgba(255, 255, 255, 0.38)'
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.38)'
  }
}))(MuiSlider);

export const styles = theme => ({
  root: {
    width: 300,
    display: 'flex'
  },
  valueBox: {
    borderRadius: 5,
    background: theme.palette.grey[300],
    minWidth: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 6px',
    ...theme.typography.caption
  }
});

export const useSliderStyles = makeStyles(styles);
